import { isContactCorn } from '@eigtech/contacts-types'
import { GetAppointmentsApiSchema, GetAppointmentsResponse } from '@eigtech/summarizer-types'
import { contextualGet, queryOptions, useQuery } from '@eigtech/ui-shared-api'
import { GetAppointmentsRequest, summarizerBasePath } from './constants'

type QueryKey = (string | GetAppointmentsRequest)[]

const getJobAppointments = async ({
  contactId,
  assignmentType,
  filter,
}: GetAppointmentsRequest) => {
  const { appointments } = await contextualGet<GetAppointmentsResponse>(
    `${summarizerBasePath}/appointments/${contactId}/${assignmentType}`,
    {
      searchParams: { filter: encodeURI(JSON.stringify(filter)) },
    }
  )
  return appointments
}

export const getJobAppointmentsQueryOptions = (
  request: GetAppointmentsRequest,
  queryKey: QueryKey
) => {
  return queryOptions({
    queryKey,
    queryFn: () => getJobAppointments(request),
    enabled:
      isContactCorn(request.contactId.trim()) &&
      GetAppointmentsApiSchema.params.shape.assignmentType.safeParse(request.assignmentType.trim())
        .success,
  })
}

export const useGetJobAppointments = (request: GetAppointmentsRequest, queryKey: QueryKey) => {
  return useQuery(getJobAppointmentsQueryOptions(request, queryKey))
}
